// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import BaseModel from '@glittr/frontend-core/src/plugins/servicelayer/serviceTypes/baseModel';
import ResourceLinkViewModel from '../../../../viewModel/resource/ResourceLinkViewModel';
import DynamicFormFieldResourceViewModel from '../../../../viewModel/resource/DynamicFormFieldResourceViewModel';
import DynamicFormResourceViewModel from '../../../../viewModel/resource/DynamicFormResourceViewModel';
import DynamicFormResourceDTO from '../../dto/resource/DynamicFormResourceDTO';

export default abstract class DynamicFormResourceModel extends BaseModel<DynamicFormResourceDTO> {
  /**
  * @type {uuid}
  */
  get id() { return this.dto.id; }
  set id(value) { this.dto.id = value; }
  /**
  */
  get links() { return this.getArrayModels(() => this.dto.links, ResourceLinkViewModel)!; }
  set links(value) { this.setArrayModels(() => this.dto.links, value); }
  /**
  */
  get description() { return this.dto.description; }
  set description(value) { this.dto.description = value; }
  /**
  */
  get formFields() { return this.getArrayModels(() => this.dto.formFields, DynamicFormFieldResourceViewModel)!; }
  set formFields(value) { this.setArrayModels(() => this.dto.formFields, value); }

  protected transformFromQuery(queries: Record<string, string>): void {
    const qs = {} as Record<string, string>;
    Object.keys(queries).forEach((key) => { qs[key.toLowerCase()] = queries[key]; });
    let value: any;
    this.dto.id = qs.id;
    this.dto.description = qs.description;
  }
}
